// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath, isGymboree } from '@tcp/core/src/utils';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  PointsAndRewardsWrapper,
  PointsAndRewardsTextWrapper,
  DetailsLinkWrapper,
} from '../styles/PointsAndRewards.style';

const PointsAndRewards = () => {
  let url = 'double-up';
  if (isGymboree()) {
    url = 'reward-events';
  }

  const pointsAndRewardsTextLabel = getDynamicLabelValues(
    'dynamic.browse_d.lbl_brierley_promo_text_generic_pdp'
  );
  const pointsAndRewardsLabel = pointsAndRewardsTextLabel?.split('##') || '';

  return pointsAndRewardsLabel ? (
    <PointsAndRewardsWrapper
      to={`/content?contentType=${url}`}
      asPath={`/content/${url}`}
      fontSizeVariation="large"
      anchorVariation="primary"
      className="promotion-section-pdp-wrapper"
      useRouterNavigation
    >
      <Image src={getIconPath('mpr_icon')} alt="" className="promotion-section-pdp-icon" />
      <PointsAndRewardsTextWrapper
        component="p"
        className="points-and-rewards promotion-section-pdp-text"
        fontFamily="secondary"
      >
        {pointsAndRewardsLabel[0] && (
          <BodyCopy component="span" className="points-and-rewards-1" fontFamily="secondary">
            {pointsAndRewardsLabel[0]}
          </BodyCopy>
        )}
        {pointsAndRewardsLabel[1] && (
          <BodyCopy component="span" className="points-and-rewards-or" fontFamily="secondary">
            {pointsAndRewardsLabel[1]}
          </BodyCopy>
        )}
        {pointsAndRewardsLabel[2] && (
          <BodyCopy component="span" className="points-and-rewards-2" fontFamily="secondary">
            {pointsAndRewardsLabel[2]}
          </BodyCopy>
        )}
      </PointsAndRewardsTextWrapper>
      <DetailsLinkWrapper
        className="promotion-section-pdp-text details-text"
        fontFamily="secondary"
        component="span"
      >
        Details
      </DetailsLinkWrapper>
      <div className="promotion-section-pdp-left-arrow">
        <Image src={getIconPath('right-arrow-plcc')} alt="" />
      </div>
    </PointsAndRewardsWrapper>
  ) : null;
};

export default errorBoundary(PointsAndRewards);
